// SPDX-FileCopyrightText: 2022 Dusan Mijatovic (dv4all)
// SPDX-FileCopyrightText: 2022 dv4all
//
// SPDX-License-Identifier: Apache-2.0

export const app = {
  title: 'Klimaatonderzoek Initiatief Nederland',
  unsavedChangesMessage: 'Moving away from editing will discard your changes. This action can not be undone.'
}
